function ArrowUpIcon({ onClick }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 -960 960 960"
      className="pt-1 cursor-pointer"
      onClick={onClick}
    >
      <path d="M480-528 296-344l-56-56 240-240 240 240-56 56z" />
    </svg>
  );
}

export default ArrowUpIcon;
